import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../../components/Layout'
import ServiceFooter from '../../components/ServiceFooter'

import { equipmentServiceItems } from '../../serviceCategories'
import ServiceMenuItem from '../../components/ServiceMenuItem'

const Remote = () => {
  const {
    site: {
      siteMetadata: { title },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Layout>
      <Helmet>
        <html className="temp" lang="ja" />
        <title>{`駐車場機器 | ${title}`}</title>
        <meta
          name="description"
          content="アイテックは大規模運営事業者から小規模オーナーまでニーズに沿った機器を提供します。"
        />
      </Helmet>

      <div className="common-header clearfix">
        <p className="category pc-only">製品・サービス</p>
        <h1>駐車場機器</h1>
        <p className="category sp-only">製品・サービス</p>

        <div className="breadcrumb">
          <li>
            <Link to={`/`}>トップページ</Link>
          </li>
          /
          <li>
            <Link to={`/service`}>製品・サービス</Link>
          </li>
          /<li>駐車場機器</li>
        </div>
      </div>

      <div className="main-wrapper middle-toppage equipment">
        <div className="row">
          <div className="container empty"></div>
        </div>

        <div className="row">
          <div className="h-wrapper">
            <h2>アイテックの駐車場機器</h2>
          </div>
        </div>

        <div className="row">
          <div className="container top">
            <h4>
              大規模運営事業者から小規模オーナーまでニーズに沿った機器を提供
            </h4>

            <p>
              予算、用途、土地の形状に合わせた、機器の選択が可能です。営業による最適な機器のご提案も可能です。
            </p>

            <h5>機器の選び方</h5>

            <img
              class="big-picture pc-only"
              src="/img/how-to-choice-equipment.svg"
              alt="車室数と予算を元にした最適な機器の選び方"
            />
            <img
              class="big-picture sp-only"
              src="/img/how-to-choice-equipment-small.svg"
              alt="車室数と予算を元にした最適な機器の選び方"
            />
            <p>
              *ナンバー認識システムは、土地の形状に合わせて、2タイプの併設が可能です
            </p>
          </div>
        </div>

        <div class="row bottom">
          <div className="container top">
            <h5>関連ページ</h5>
            <div className="service-mega__items">
              {equipmentServiceItems?.map((item) => (
                <ServiceMenuItem
                  key={`equipment-${item.to || item.href || 'noop'}`}
                  item={item}
                />
              ))}
            </div>
          </div>
        </div>

        <ServiceFooter />
      </div>
    </Layout>
  )
}

export default Remote
